import { render } from "./OurProducts.vue?vue&type=template&id=28e75501&scoped=true"
import script from "./OurProducts.vue?vue&type=script&lang=js"
export * from "./OurProducts.vue?vue&type=script&lang=js"

import "./OurProducts.vue?vue&type=style&index=0&id=28e75501&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e75501"]])

export default __exports__